export { Tooltip as ButtonTooltip } from '../core/enum';
export var ButtonColor;
(function (ButtonColor) {
    ButtonColor["default"] = "default";
    ButtonColor["primary"] = "primary";
    ButtonColor["gray"] = "gray";
    ButtonColor["blue"] = "blue";
    ButtonColor["red"] = "red";
    ButtonColor["green"] = "green";
    ButtonColor["yellow"] = "yellow";
    ButtonColor["purple"] = "purple";
    ButtonColor["dark"] = "dark";
})(ButtonColor || (ButtonColor = {}));
export var FuncType;
(function (FuncType) {
    FuncType["flat"] = "flat";
    FuncType["raised"] = "raised";
    FuncType["link"] = "link";
})(FuncType || (FuncType = {}));
export var ButtonType;
(function (ButtonType) {
    ButtonType["button"] = "button";
    ButtonType["submit"] = "submit";
    ButtonType["reset"] = "reset";
})(ButtonType || (ButtonType = {}));
